@let availableStates = availableStates$ | async;

<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/property-search"></ion-back-button>
    </ion-buttons>
    <ion-title>Advanced Search</ion-title>
  </ion-toolbar>
</red-header-content>
<red-page-content>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <ion-list [inset]="true" lines="full" class="no-last-line">
      <ion-item>
        <ion-input
          redErrorMessage
          labelPlacement="stacked"
          placeholder="123 Main Street"
          inputmode="text"
          type="text"
          formControlName="address"
        >
          <div slot="label">Street Address:<ion-text color="danger">*</ion-text></div>
        </ion-input>
      </ion-item>
      <ion-item>
        <ion-input
          redErrorMessage
          labelPlacement="stacked"
          placeholder="123"
          inputmode="text"
          type="text"
          formControlName="unitNumber"
        >
          <div slot="label">Unit:</div>
        </ion-input>
      </ion-item>
    </ion-list>

    <div class="tw:px-4">
      <ion-segment (ionChange)="segmentChange($event)" [value]="selectedTab">
        <ion-segment-button [value]="pageTabs.ZipCode">
          <ion-label>Zip Code</ion-label>
        </ion-segment-button>
        <ion-segment-button [value]="pageTabs.CityState">
          <ion-label>City & State</ion-label>
        </ion-segment-button>
      </ion-segment>
    </div>

    <ion-list [inset]="true" lines="full" class="no-last-line">
      @switch (selectedTab) { @case (pageTabs.ZipCode) {
      <ion-item>
        <ion-input
          redErrorMessage
          labelPlacement="stacked"
          placeholder="55555"
          inputmode="tel"
          type="text"
          formControlName="zip"
          [maskito]="zipMask"
          [maskitoElement]="maskPredicate"
          [minlength]="5"
          [maxlength]="5"
        >
          <div slot="label">Zip Code:<ion-text color="danger">*</ion-text></div>
        </ion-input>
      </ion-item>
      } @case (pageTabs.CityState) {
      <ion-item>
        <ion-input
          redErrorMessage
          labelPlacement="stacked"
          placeholder="Anytown"
          inputmode="text"
          type="text"
          formControlName="city"
        >
          <div slot="label">City:<ion-text color="danger">*</ion-text></div>
        </ion-input>
      </ion-item>
      @if (availableStates) {
      <red-searchable-select
        redErrorMessage
        [redRequired]="true"
        formControlName="state"
        [options]="availableStates"
        placeholder="Select state"
        searchPlaceholder="Search state..."
      >
        <span searchable-select-label class="tw:whitespace-normal">
          State:
          <ion-text color="danger">*</ion-text>
        </span> </red-searchable-select
      >} } }
    </ion-list>

    <ion-button class="tw:m-4" expand="block" (click)="onSubmit()" [disabled]="!form.valid">
      Search<ion-icon slot="start" name="search-outline"></ion-icon>
    </ion-button>
  </form>
</red-page-content>
